import React from "react";
import { Link } from "react-router-dom";
import {
  MDBRow,
  MDBContainer,
} from "mdbreact";
import {message} from "antd";

class SupportUpdate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filteredList: [],
        loading: false,
        data: [],
    }
  }

  componentDidMount() {
    // console.log(this.props.search)
    // console.log(this.props.data[this.props.search])
      this.loadList();
    //console.log(this.props.data.search)
    let filteredDatas = this.state.data.filter(data => {
      return (data.title.toLowerCase().includes(this.props.search))
    })
    //console.log('filtered datas12', filteredDatas)

    this.setState({
      filteredList: filteredDatas
    })
  }
    loadList = async () => {
        this.setState({loading: true});
        try {
            let first;
            first = await this.props.db.collection('supportUpdate')
                .where('delete', '==', false)
                .orderBy("publishDate","desc");
            first.get()
                .then((snapshot) => {
                    if(snapshot.docs.length > 0) {
                        let supports = [];
                        snapshot.forEach((doc) => {
                            let data = {};
                            data.id = doc.id;
                            data.title = doc.data()['title'];
                            data.publishDate = doc.data()['publishDate'];
                            supports.push(data)
                        })
                        console.log('supports', supports);
                        this.setState({data: supports});
                    }
                })

        } catch (err) {
            message.error("Failed to load data");
        } finally {
            this.setState({loading: false});
        }
    };
    n =(n)=> {
        return n > 9 ? "" + n: "0" + n;
    }
  render() {
    return (
      <>
        <MDBContainer>
          <MDBRow style={{height: 100, background: '#2e75b6', color: '#ffffff', alignItems: 'center', paddingLeft: 20, paddingRight: 20, justifyContent: 'space-between'}}>
            <Link to={'/support'} style={{color: '#ffffff'}}>
              <img src="/logo.png" className="img-fluid" alt="HOME" style={{height: 22, marginRight: 10}} />
              サポートサイト
            </Link>
            <div>
              <Link to={'/support#operation'} style={{padding: 10, cursor: 'pointer', color: '#ffffff'}}>基本的な操作</Link>
              <Link to={'/support#faq'} style={{padding: 10, cursor: 'pointer', color: '#ffffff'}}>よくある質問</Link>
              <Link to={'/support#information'} style={{padding: 10, cursor: 'pointer', color: '#ffffff'}}>お役立ち情報</Link>
            </div>
          </MDBRow>
          <MDBRow>
            <div style={{padding: '10px 20px'}}>
              {
                this.props.data.categoryBreadcrumbArray['update'].map((v, i) => {
                  return <><Link to={'/support'}>{v}</Link> » </>
                })
              }
              {this.props.data.categoryTitle['update']}
            </div>
          </MDBRow>
          <MDBRow style={{display: 'flex', flexDirection: 'column', backgroundColor: '#f5f5f5'}}>
            <div style={{display: 'grid', columnGap: 20, rowGap: 20, backgroundColor: '#ffffff', margin: 50, padding: 40}}>
              <h3>アップデート情報</h3>
              {this.state.data.map((v) => {
                return <Link to={`/supportUpdate/${v.id}`}>
                    <div style={{padding: 30, background: '#f6f6f6', display: 'flex', flexDirection: 'column'}}>
                  <div style={{color: '#000000', marginBottom: 20}}>{v.title}</div>
                  <span style={{color: '#4b4f58'}}>{v.publishDate.toDate().getFullYear() + '/'
                      + this.n(v.publishDate.toDate().getMonth()+1) + '/'
                      + this.n(v.publishDate.toDate().getDate())}</span>
                  {/*TODO: read more button*/}
                  {/*<div>*/}
                  {/*  <Link to={v.link} style={{fontWeight: 400, lineHeight: 1, letterSpacing: 5, fontSize: '1.13rem', borderRadius: 50, backgroundColor: '#1e92e0', padding: 'calc(0.567em + 2px) calc(1.233em + 2px)', color: '#ffffff'}}>Read More</Link>*/}
                  {/*</div>*/}
                </div>
                </Link>
              })}
            </div>
          </MDBRow>
        </MDBContainer>
      </>
    )
  }
}
export default SupportUpdate;

